// Slick slider
if( jQuery('.carousel .slides').length > 0 ){
    jQuery('.carousel .slides').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000
    });
}